module.exports = __webpack_public_path__ + "img/2.767e4110.jpg";